// extracted by mini-css-extract-plugin
module.exports = {"container":"qb","copy":"rb","field":"sb","error":"tb","disabled":"ub","termsContainer":"vb","termsHeading":"wb","termsCopy":"xb","submit":"yb","srOnly":"zb"};